;(() => {
  if (typeof window.initilizedSelect !== 'undefined') return
  window.initilizedSelect = true

  const $containers = document.querySelectorAll('[data-select=container]')

  $containers.forEach(($container) => {
    const $button = $container.querySelector('[data-select=button]')
    const $arrow = $button.querySelector('[data-select=arrow]')
    const $list = $container.querySelector('[data-select=list]')
    const $items = $list.querySelectorAll('[data-select=item]')
    const $current = $container.querySelector('[data-select=current]')
    const $input = $container.querySelector('[data-select=input]')

    const isListOpen = () => {
      return !$list.classList.contains('hidden')
    }

    const openList = () => {
      $list.classList.remove('hidden')
      if ($arrow) {
        $arrow.classList.remove('rotate-90')
        $arrow.classList.add('-rotate-90')
      }
    }

    const closeList = () => {
      $list.classList.add('hidden')
      if ($arrow) {
        $arrow.classList.remove('-rotate-90')
        $arrow.classList.add('rotate-90')
      }
    }

    const dispatchChangeEvent = ($item) => {
      const event = new CustomEvent('select:change', {
        detail: {
          label: $item.textContent,
          value: $item.getAttribute('data-value'),
        },
      })
      $item.dispatchEvent(event)
    }

    const toggleList = () => {
      isListOpen() ? closeList() : openList()
    }

    $button.addEventListener('click', () => {
      toggleList()
    })

    $items.forEach(($item) => {
      $item.addEventListener('click', () => {
        closeList()
        dispatchChangeEvent($item)
        $current.textContent = $item.textContent
      })
    })

    // Close list when clicking outside
    document.addEventListener('click', (e) => {
      if (isListOpen() && !$container.contains(e.target)) {
        closeList()
      }
    })
  })
})()
